import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private static _instance: ConfigService;
  config!: IConfig;

  constructor() {
    ConfigService._instance = this;
    // Pre-populate from main.ts pre-fetch if available (before Angular DI is ready)
    const preloaded = (window as any).__APP_CONFIG__;
    if (preloaded) {
      this.config = preloaded;
    }
  }

  setConfig(config: IConfig) {
    this.config = config;
  }

  getConfig(): IConfig {
    return this.config;
  }

  /**
   * Static accessor for use in non-DI contexts (e.g., prototype-based endpoint builders).
   * Config is guaranteed to be set before any Angular service or component is rendered.
   */
  static getInstance(): ConfigService {
    return ConfigService._instance;
  }
}

export interface IConfig {
  production: boolean;
  apiUrl: string;
  eidSdkUrl: string;
  topNavBundleUrl: string;
  aiComponentsBundleUrl: string;
  writingAssistantApiUrl: string;
  powerDMSClientId: string;
  powerDMSURL: string;
  powerDMSBASEURL: string;
  powerDMSAudience: string;
  powerDMSTenantKey: string;
  powerDMSFilePickerOrigin: string;
  powerDMSFilePickerURL: string;
  powerDMSRoute: string;
  powerDMSGraphqlBaseURL: string;
  gainSightPXCode: string;
  gainSightEnviromentPrefix: string;
  froalaLicenseKey: string;
  appDynamics: {
    isEnabled: boolean;
    configurationScriptPath: string;
    scriptPath: string;
    appKey: string;
  };
  authSettings: {
    authServerUrl: string;
    clientId: string;
    scope: string;
    ssoEnabled: boolean;
  };
  EIDChangePassword: string;
  EIDAdminChangePasswordUrl: string;
  passwordResetAllowedDomains: string[];
  appSwitcher: {
    environment: string;
    productsUrl: string;
  };
}
